import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24",
  fill: "#DAD8FC",
  rx: "12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#6C40E5",
  d: "M13.773 7.043c.054.035.095.09.117.156a.36.36 0 0 1 .007.206l-.982 3.657h1.812a.25.25 0 0 1 .15.052q.069.051.1.137a.36.36 0 0 1 .019.178.33.33 0 0 1-.07.16l-4.364 5.313a.26.26 0 0 1-.16.095.24.24 0 0 1-.176-.04.3.3 0 0 1-.117-.156.36.36 0 0 1-.006-.206l.982-3.658H9.273a.25.25 0 0 1-.15-.05.3.3 0 0 1-.1-.138.35.35 0 0 1 .051-.338l4.364-5.313a.26.26 0 0 1 .159-.095c.06-.01.123.004.176.04M7.5 3l.003 2.999L10.098 7.5 7.5 6.003 4.902 7.5l2.595-1.501zM15.75 16.5l.002 2.249 1.947 1.126-1.949-1.123-1.949 1.123 1.947-1.126z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }